export const ECT_MESSAGE_LOAD_FAIL = 'ECT_MESSAGE_LOAD_FAIL';
export const ERP_MESSAGE_LOAD_FAIL = 'ERP_MESSAGE_LOAD_FAIL';
export const ECT_GENERAL_PREFERENCES_LOAD_FAIL =
  'ECT_GENERAL_PREFERENCES_LOAD_FAIL';
